import s from '../../styles/staff.module.css';

// Simple prev/next pager. Renders nothing when there's only a single page.
export function Pagination({ page, pageCount, onPage }) {
  if (pageCount <= 1) return null;
  return (
    <div className={s.pagination}>
      <button className={s.pageBtn} onClick={() => onPage(page - 1)} disabled={page <= 1}>Prev</button>
      <span className={s.pageInfo}>Page {page} of {pageCount}</span>
      <button className={s.pageBtn} onClick={() => onPage(page + 1)} disabled={page >= pageCount}>Next</button>
    </div>
  );
}
